import { toCurrencyTruncated } from '@simplywallst/formatting';
import type {
  AnalysisState,
  Shareholder,
  Formatting,
} from '@/pages/CompanyReport/redux/interface/interface';

export const calculateHoldingValue = (
  shareholder: Shareholder,
  analysis: AnalysisState,
  formatting: Formatting
) => {
  return toCurrencyTruncated(
    (shareholder.percentOfSharesOutstanding / 100) *
      analysis.marketCapRawData.listing,
    1,
    formatting.tradingItemCurrencyISO
  );
};
